<template>
  <div class="fos"> 
    <div class="fos-left">
      <v-list class="fos-left-list">
        <template             
          v-for="(item, i) in items"
          >
           <v-list-tile
            :key="i"
            :class="activeItem === item ? 'fos-active' : ''"
            avatar
            @click="activeItem = item"
          >
            <v-list-tile-avatar>
              <img :src="item.avatar" >
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-text="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="'divider-'+i"/>
        </template>
        </v-list>
    </div>
    <div class="fos-right" v-if="activeItem.type">
      <div class="fos-right-content">
        <div class="subheading"> {{activeItem.title}}</div>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
                type="number"
                v-model="phone"
                label="Enter Mobile Number"
                required
                :rules="phoneRule"
                solo
          ></v-text-field>
          <v-text-field
                type="number"
                v-model="amount"
                :rules="rule"
                required
                label="Amount"
                solo
          ></v-text-field>
        </v-form>
         <v-btn @click="submit()"  color="secondary" dark>Submit</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeItem: {},
      phone: '',
      valid: false,
      amount: '',
      items: [
        {
          title: "BSNL - Prepaid",
          type:"BsnlPrepaid",
          avatar: require('../assets/bsnl.png')
        },
        {
          title: "BSNL - Postpaid",
          type:"BsnlPostpaid",
          avatar: require('../assets/bsnl.png')
        }
      ],
      rule: [v => !!v || "Amount is required"],
      phoneRule: [
        v => !!v || 'Phone Number is required',
        v => !!v && v.length === 10 || '10 Digit Number Required'
      ],
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if(vm.user==null || !vm.user.phone) return vm.$root.notify("error","Login Required!")
      if(!vm.valid) return;
      let doc = {
            'MobileNo':vm.user.phone,
            'Password':vm.user.password,
            'RechargeType':"FOS",
            'ServiceName': vm.activeItem.type,
            'Amount':vm.amount,
            'RechargeNumber':vm.phone,
            'TransId':'NA',
            'Circle':"All",
            'AuthKey':vm.user.authkey,
            'Source':'json'
        }            
        vm.$root.loader = true;            
        vm.$store.dispatch("axiospost",{
                url:"MakeRecharge",
                data:doc,
        }).then(function (res) {
                vm.$root.loader = false;              
                vm.$store.dispatch("getbalance")   
                if(res.data.Status==null) vm.$root.notify("error","Try Agian!");     
                if(res.data.Status=="False"){
                if(res.data.Message=="Not Authorised."){
                    window.localStorage.removeItem("user");
                    vm.$store.dispatch("getuser");
                    vm.$router.push("/account");
                    return vm.$root.notify("error",res.data.Message);                                
                }
                    return vm.$root.notify("error",res.data.Message);
                }
                if(res.data.Status=="True"){
                    vm.$refs.form.reset();
                    return vm.$root.notify("success",res.data.Message);
                } 
                return vm.$root.notify("error",res.data.Message);                               
        }).catch(function (error) {
                vm.$root.notify("error",error);
                vm.$root.loader = false;              
        })

    }
  },
  mounted() {
    const vm = this;
    if(vm.items.length !== 0) {
      vm.activeItem = vm.items[0]
    }
  }
}
</script>

<style>
.fos {
  margin-top: 10px;
  width:  100%;
  height: 500px;
  overflow-y: auto;
  display: flex;
}
.fos-left {
  width: 250px;
  height: 100%;
}
.fos-left img {
  object-fit: contain;
}
.fos-left-list {
  background: transparent!important;
  text-transform: uppercase;

}
.fos-active {
  background:#01579b;
  color: white;  
}
.fos-right {
  flex:1;
  height: 100%;
}
.fos-right-content {
  width: 350px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
  flex-direction: column;
}
.fos-right-content .v-input {
  width: 300px;
}
.fos-right-content .subheading {
  margin-bottom: 10px;
  text-transform: uppercase;
}
.fos-right-content button {
  width: 300px;
}
</style>